<template>
    <span class="el-float" @click="$emit('click', $event)">
        <v-tooltip nudge-bottom="15" open-delay="250" bottom>
            <template v-slot:activator="{ on: show }">
                <div style="display: inline;" v-on="show">
                    <PersonAvatar
                        :person="person"
                        :size="40"
                        class-name="mr-1 mt-1"
                    ></PersonAvatar>
                </div>
            </template>
            <span>{{ person.name }}</span>
        </v-tooltip>
    </span>
</template>

<script>
import PersonAvatar from "../../components/PersonAvatar.vue";

export default {
    name: "UserButton",
    components: {
        PersonAvatar
    },
    props: {
        person: {
            type: Object,
            required: true
        }
    },
    setup() {
        return {

        };
    }
}
</script>
